import { useMemo } from 'react';
import { NavTabs } from '@shared/tabs/NavTabs';
import { PhoenixGridHeader } from '@modules/admin/Tools/LenderUtility/shared/PhoenixGridHeader';
import { Wrapper } from '@styles/CommonStyles';
import { UserMapping } from './Tabs/UserMapping';
import { ChargeBacks } from './Tabs/ChargeBacks';

const PayPlanConfig = () => {
  const tabs = useMemo(
    () => [
      {
        name: 'User Mapping ',
        component: <UserMapping />,
      },
      {
        name: 'Charge Backs ',
        component: <ChargeBacks />,
      },
    ],
    []
  );

  return (
    <Wrapper>
      <PhoenixGridHeader title="Pay Plan" />
      <NavTabs data={tabs} loading={false} />
    </Wrapper>
  );
};

export default PayPlanConfig;
